import { useState, useEffect } from 'react';
import api from './api';

let cache = null;
let cachePromise = null;

export function invalidateProductosCache() {
  cache = null;
  cachePromise = null;
}

export function useProductos() {
  const [productos, setProductos] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) { setProductos(cache); setLoading(false); return; }
    if (!cachePromise) cachePromise = api.get('/products').then(r => r.data);
    cachePromise
      .then(data => { cache = data; setProductos(data); setLoading(false); })
      .catch(() => { cachePromise = null; setLoading(false); });
  }, []);

  return { productos, loading };
}
